import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as RangeWithIdList from 'types/BaseIngredient/Search/RangeWithIdList';

const rb = new ReducerBuilder<RangeWithIdList.Type>();
export const createBaseIngredientRangesReducerLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'BaseIngredientRanges/LoadedFromBackend'
);

export const baseIngredientRangesReducer = rb.createReducer();

const rbArchived = new ReducerBuilder<RangeWithIdList.Type>();
export const createBaseIngredientRangesArchivedReducerLoadedAction =
	rbArchived.createActionForReducer(
		payloadReducer((x) => x),
		'BaseIngredientRangesArchived/LoadedFromBackend'
	);

export const baseIngredientRangesReducerArchived = rbArchived.createReducer();
